import { useEffect, useRef } from "react";

// Logos partenaires — remplace les URLs par tes vrais logos
import ifv from '../../../assets/logos_partenaires/LOGO-IFV-blanc.png'
import inrae from '../../../assets/logos_partenaires/logo-inrae.png'
import TI from '../../../assets/logos_partenaires/terreInnovia_logo.png'
import capprot from '../../../assets/logos_partenaires/logo-Cap-Proteines.png'
import mans from '../../../assets/logos_partenaires/logo-universite-du-mans.png'
import fabacee from '../../../assets/logos_partenaires/Fabacée.png'
import intercereal from '../../../assets/logos_partenaires/Logo-INTERCEREALESV-300x132.png'
import ARTB from '../../../assets/logos_partenaires/artb.png'
import acta from '../../../assets/logos_partenaires/ACTA-logo.png'
import sunagri from '../../../assets/logos_partenaires/Logo-Sun-agri-2021-LD.png'
import pluriagri from '../../../assets/logos_partenaires/pluriagri.png'
import ecophyto from '../../../assets/logos_partenaires/Logo-ecophyto.png'
import ofb from '../../../assets/logos_partenaires/logo-ofb-actualite.jpg'
import perqo from '../../../assets/logos_partenaires/logo-du-perqo.jpg'
import idf from '../../../assets/logos_partenaires/Logo-region-ile-de-france.png'

const partners = [
  { name: "IFV", logo: ifv },
  { name: "INRAE", logo: inrae },
  { name: "Terre Innovia", logo: TI },
  { name: "Cap Protéines +", logo: capprot },
  { name: "Université du Mans", logo: mans },
  { name: "Fabacée", logo: fabacee },
  { name: "Intercéréales", logo: intercereal },
  { name: "ARTB", logo: ARTB },
  { name: "ACTA", logo: acta },
  { name: "Sun'Agri", logo: sunagri },
  { name: "Pluriagri", logo: pluriagri },
  { name: "Écophyto", logo: ecophyto },
  { name: "OFB", logo: ofb },
  { name: "PERQO", logo: perqo },
  { name: "Région Île-de-France", logo: idf },
];
// Composant logo : affiche une vraie image ou un fallback texte stylé
function CarrousselLogo({ name, logo }) {
  return (
    <div style={styles.logoCard}>
      {logo ? (
        <img src={logo} alt={name} style={styles.logoImg} />
      ) : (
        <span style={styles.logoText}>{name}</span>
      )}
    </div>
  );
}

export default function PartnersCarousel() {
  const trackRef = useRef(null);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    let animId;
    let pos = 0;
    const speed = 1; // px par frame — ajuste la vitesse ici

    const halfWidth = track.scrollWidth / 2;

    const animate = () => {
      pos += speed;
      if (pos >= halfWidth) pos = 0;
      track.style.transform = `translateX(-${pos}px)`;
      animId = requestAnimationFrame(animate);
    };

    animId = requestAnimationFrame(animate);

    // Pause au survol
    const pause = () => cancelAnimationFrame(animId);
    const resume = () => { animId = requestAnimationFrame(animate); };
    track.addEventListener("mouseenter", pause);
    track.addEventListener("mouseleave", resume);

    return () => {
      cancelAnimationFrame(animId);
      track.removeEventListener("mouseenter", pause);
      track.removeEventListener("mouseleave", resume);
    };
  }, []);

  // On duplique les logos pour créer l'effet infini
  const doubled = [...partners, ...partners];

  return (
    <section style={styles.section}>
      {/* Bandeau scroll */}
      <div style={styles.wrapper}>
        {/* Dégradés flous sur les côtés */}
        <div style={{ ...styles.fade, left: 0, background: "linear-gradient(to right, #fff 0%, transparent 100%)" }} />
        <div style={{ ...styles.fade, right: 0, background: "linear-gradient(to left, #fff 0%, transparent 100%)" }} />

        <div style={styles.track} ref={trackRef}>
          {doubled.map((p, i) => (
            <CarrousselLogo key={i} name={p.name} logo={p.logo} />
          ))}
        </div>
      </div>
    </section>
  );
}

const styles = {
  section: {
    width: "100%",
    boxSizing: "border-box",  // ← ajoute ça
    padding: "20px 60px 20px 60px",
    background: "#ffffff",
    overflow: "hidden",
  },
  wrapper: {
    position: "relative",
    width: "100%",
    overflow: "hidden",
  },
  fade: {
    position: "absolute",
    top: 0,
    bottom: 0,
    width: "120px",
    zIndex: 2,
    pointerEvents: "none",
  },
  track: {
    display: "flex",
    alignItems: "center",
    gap: "0px",
    willChange: "transform",
    width: "max-content",
  },
  logoCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "180px",
    height: "100px",
    margin: "0 12px",
    padding: "0 24px",
    background: "#ffffff",
    border: "1.5px solid #EAF4D8",
    borderRadius: "10px",
    boxShadow: "0 2px 12px rgba(26,33,63,0.06)",
    transition: "border-color 0.25s, box-shadow 0.25s, transform 0.25s",
    cursor: "default",
    flexShrink: 0,
  },
  logoImg: {
    maxHeight: "80px",
    maxWidth: "140px",
    objectFit: "contain",
    filter: "grayscale(30%)",
    transition: "filter 0.3s",
  },
  logoText: {
    fontSize: "16px",
    fontWeight: "700",
    color: "#1A213F",
    letterSpacing: "0.02em",
    userSelect: "none",
  },
};
